import React from "react";
import { useState,useEffect } from "react";
import { useBeforeUnload, useLocation, useNavigate } from "react-router-dom";
import WestIcon from "@mui/icons-material/West";
import CloseIcon from "@mui/icons-material/Close";
import "./DeliveryInvoiceEdit.css";
import { useSelector } from "react-redux";
import { DeliveryInvoiceBatchDetails, DeliveryInvoiceSkuDetails, SalesReasonDetails } from "../../types/types";
import { CollectionsState } from "../../stateManagement/reducers/collectionReducer";
import DeliveryInvoiceReasonSelectionParent from "./DeliveryInvoiceReasonSelectionParent";
import BatchListItem from "./BatchListItem";
import { setBatchDetails, setCollectionData } from "../../stateManagement/actions/collectionActions";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { getUomLabel } from "../../components/dms_common/DmsUtils";
import { getAllProductDetailsFromDb } from "../SalesReturn/SalesReturnService";


const DeliveryInvoiceEdit: React.FC = () => {

  const navigate = useNavigate();
  const location:{state:any} = useLocation();
  const [expandedBatch, setExpandedBatch] = useState<DeliveryInvoiceBatchDetails | null>(null);
  const { batchDetails } = useSelector((state: {collections:CollectionsState}) => state.collections);
  const [editedDetails, setEditedDetails] = useState<DeliveryInvoiceBatchDetails[]>([]);
  const selectedRowToEdit:DeliveryInvoiceSkuDetails | null = location.state?.rowData;
  const {caseUnitLabel,otherUnitLabel,packUnitLabel} = getUomLabel();
  const collectiondata = useSelector((state: {collections:CollectionsState}) => state?.collections);
  const [loaded,setLoaded] = useState(false);
  const [disabledUoms, setDisabledUoms] = useState<string[]>([]);
  useBeforeUnload(
    React.useCallback(() => {
        localStorage.deliveryCollectionData = JSON.stringify(collectiondata);
    }, [collectiondata])
  );

  useEffect(()=>{
    if(localStorage.deliveryCollectionData){
      setCollectionData(JSON.parse(localStorage.deliveryCollectionData));
    }
    delete localStorage.deliveryCollectionData;
    setLoaded(true);
  },[]);

  useEffect(() => {
    if(!selectedRowToEdit){
      navigate(-1);
      return;
    }
    if(!loaded){
      return;
    }
    const selectedBatchData:{[key:string]:SalesReasonDetails[]} = (batchDetails && selectedRowToEdit && batchDetails[selectedRowToEdit.batchCode] && JSON.parse(JSON.stringify(batchDetails[selectedRowToEdit.batchCode]))) ??  {};
    let newBatchDetails:DeliveryInvoiceBatchDetails[] = selectedRowToEdit?.batchIds.map((row)=>{
      return {
        batchId: row.batchId,
        caseQty: row.caseQty,
        otherQty: row.otherQty,
        pieceQty: row.pieceQty
      };
    }) ?? [];
    newBatchDetails.forEach((batchData)=>{
      batchData.reasonDetails = selectedBatchData[batchData.batchId];
    })
    setEditedDetails(newBatchDetails);
    setExpandedBatch(null);
    
  }, [loaded]);

  const handleOnClose = () => {
    navigate(-1);
  };

  const filterReasonDetails = (reasons:SalesReasonDetails[])=>{
    return reasons.filter(reasonDetail=>{
      const qty = reasonDetail.caseQty+reasonDetail.otherQty+reasonDetail.pieceQty;
      if(qty>0 && reasonDetail.reason){
        return true;
      }
      if(qty>0 && !reasonDetail.reason){
        openPopup("Error", "Please add reasons for returns");
        throw Error("reason details not added");
      }
      return false;
    });
  }
  const handleOnSubmit = ()=>{
    const newBatchDetails = batchDetails ? JSON.parse(JSON.stringify(batchDetails)) : {};
    if(selectedRowToEdit!=null){
      newBatchDetails[selectedRowToEdit.batchCode] = newBatchDetails[selectedRowToEdit.batchCode] ?? {};
      editedDetails.forEach(batch=>{
        const reasons = batch.reasonDetails??[];
        const filteredReasons = filterReasonDetails(reasons);
        newBatchDetails[selectedRowToEdit.batchCode][batch.batchId] = filteredReasons;
      })
      setBatchDetails(newBatchDetails);
    }
    handleOnClose()
  }

  const handleReset = () => {
    let newBatchDetails:DeliveryInvoiceBatchDetails[] = selectedRowToEdit?.batchIds.map((row)=>{
      return {
        batchId: row.batchId,
        caseQty: row.caseQty,
        otherQty: row.otherQty,
        pieceQty: row.pieceQty
      };
    }) ?? [];
    setEditedDetails(newBatchDetails);
    // selectedRowToEdit?.batchIds?.forEach(batchObject=>delete batchObject.reasonDetails);
    setExpandedBatch(null);
    // setStaticBatches(selectedRowToEdit?.batchIds || []);
  };

  const handleChangeExpandedBatch = async (batch: DeliveryInvoiceBatchDetails) => {
    try{
      const productDetails = await getAllProductDetailsFromDb();
      const skuCode = selectedRowToEdit?.batchCode;
      if(productDetails && skuCode && productDetails[skuCode] && productDetails[skuCode].otherUnitToPieceQuantity == 0){
        setDisabledUoms(["otherQty"]);
      }else{
        setDisabledUoms([]);
      }
    }catch(error){
        console.log(error);
    }
    setExpandedBatch((prevState: DeliveryInvoiceBatchDetails | null) =>
      prevState?.batchId === batch?.batchId ? null : batch
    );
  };

  return (
    <div className="edit-return-container">
      <header>
        <div>
          <WestIcon style={{ cursor: "pointer" }} onClick={() => navigate(-1)} />
          <p> Add Return Qty for {selectedRowToEdit?.skuName} ({selectedRowToEdit?.batchCode}) </p>
        </div>
        <CloseIcon style={{ cursor: "pointer" }} onClick={handleOnClose} />
      </header>
      <div className="edit-return-model-container">
        <div className="inside-header">
            <div className="inside-header-container">
                <div className="inside-header-label">SKU Code</div>
                <div className="inside-header-value">{selectedRowToEdit?.batchCode}</div>
            </div>

            <div className="inside-header-container">
                <div className="inside-header-label">SKU Name</div>
                <div className="inside-header-value">{selectedRowToEdit?.skuName}</div>
            </div>

            <div className="inside-header-container">
                <div className="inside-header-label">Sold Qty</div>
                <div className="value-group">
                    {caseUnitLabel && <div className="inside-header-value">{selectedRowToEdit?.totalCaseQty} {caseUnitLabel}</div>}
                    {otherUnitLabel && <div className="inside-header-value">{selectedRowToEdit?.totalOtherQty} {otherUnitLabel}</div>}
                    {packUnitLabel && <div className="inside-header-value">{selectedRowToEdit?.totalPieceQty} {packUnitLabel}</div>}
                </div>
            </div>
        </div>
        <div className="inside-body">
            <div className="batch-id-text-delivery">
                Batch ID
            </div>
            <div className="edit-left">
                <div className="batches-list-container-delivery">
                    <div className="batch-list-heading">
                        <span>Select a batch ID to add damage quantity</span>
                    </div>
                    <div className="batches-list-delivery">
                      {editedDetails.length ? editedDetails.map((batch) => {
                        return (
                            <BatchListItem
                                key={batch.batchId}
                                batch={batch}
                                isSelected={expandedBatch?.batchId === batch.batchId}
                                onSelect={() => handleChangeExpandedBatch(batch)}
                            />
                        );
                      }):
                      <div className="batch-list-heading center">
                          <span>No Batch ID</span>
                      </div>
                      }
                    </div>
                </div>
            </div>
            {expandedBatch?.batchId && (
            <div className="edit-right-delivery">
            <div className="edit-right-delivery-top">
              <div className="edit-right-delivery-top-header">
                <p className="batch-id-nos-delivery">{expandedBatch?.batchId}</p>
              </div>
              <div className="batch-ids-container-delivery">
                <div className="reasons-parent-delivery">
                  <DeliveryInvoiceReasonSelectionParent batchData={expandedBatch} disabledUoms={disabledUoms} />
                </div>
              </div>
            </div>
          </div>
            )}
        </div>
      </div>
      <footer>
        <button className="button-reset-delivery" onClick= {handleReset}>
          <span className="button-reset-delivery-text">Reset</span>
        </button>
        <button className="button-save-delivery" onClick={() => {handleOnSubmit();}}>
          <span className="button-save-delivery-text" >Submit</span>
        </button>
      </footer>
    </div>
  );
};

export default DeliveryInvoiceEdit;
